/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  label: {
    id: 'App.ViewProperty.AffordableSetup.MNHousingDNumber.label',
    defaultMessage: 'Minnesota Housing D Number',
  },
  tooltip: {
    id: 'App.ViewProperty.AffordableSetup.MNHousingDNumber.tooltip',
    defaultMessage:
      'The Minnesota Housing Development Number. Used to identify the property in Minnesota Housing PORT reporting.',
  },
});

export default messages;
